import { Box, BoxProps } from '@chakra-ui/react/box';
import { Text } from '@chakra-ui/react/text';

import { StatusTagProps } from './types/StatusTagProps';

const progressStyle = {
  position: 'absolute',
  zIndex: 1,
  top: 0,
  left: 0,
  bottom: 0,
  background:
    'linear-gradient(90deg, var(--colors-color\\/purple\\/subtle) 0%, var(--colors-color\\/purple\\/moderate) 100%)',
  transition: '500ms',
};
const StatusTag = ({
  backgroundColor,
  className,
  fixedWidth = true,
  icon: StatusIcon,
  isRunning = false,
  progress,
  size,
  text,
  textColor,
}: StatusTagProps) => {
  let percentage = progress;
  if (!percentage || percentage < 0) {
    percentage = 0;
  }
  if (percentage > 100) {
    percentage = 100;
  }

  const calculatedPadding = ((): Pick<
    BoxProps,
    'paddingInline' | 'paddingBlock' | 'paddingInlineStart' | 'paddingInlineEnd'
  > => {
    const paddingInline = '8';
    const paddingBlock = '20';
    if (size === 'sm') {
      return {
        paddingBlock: '4',
        paddingInlineStart: '4',
        paddingInlineEnd: '8',
      };
    }
    if (size === 'md') {
      return {
        paddingInline,
        paddingBlock: '8',
      };
    }
    return {
      paddingInline,
      paddingBlock,
    };
  })();

  return (
    <Box
      as="span"
      display="flex"
      alignItems="center"
      justifyContent="center"
      backgroundColor={backgroundColor}
      borderRadius="4"
      className={className}
      gap={size === 'sm' ? '4' : '8'}
      color={textColor}
      overflow="hidden"
      width={fixedWidth ? '8.5rem' : 'auto'}
      position="relative"
      zIndex={0}
      {...calculatedPadding}
    >
      {isRunning && <Box as="span" css={progressStyle} width={`${percentage}%`} />}
      <StatusIcon
        aria-label={text}
        className="Icon"
        color="currentColor"
        position="relative"
        zIndex={2}
        size={size === 'sm' ? '16' : '24'}
      />
      {text && (
        <Text
          as="span"
          textStyle={size === 'sm' ? 'heading/h6' : 'heading/h5'}
          textTransform="uppercase"
          position="relative"
          zIndex={2}
        >
          {text}
        </Text>
      )}
    </Box>
  );
};
export default StatusTag;
